import { InjectConfig, IqConfigKey } from '@ddt-web/config-layer';
import { PasPosition } from '@ddt-web/pas';
import * as get from 'lodash/get';

/**
 * Util for helping calculate the data points for columns under the Exposure Outliers Area of Focus
 * These data points are config driven
 */
export class ExposureOutliersDataExtractorUtil {
	// data correlation mapping used to identify and calculate the relevant data for the exposure outliers
	// the order in the object is important to identify the correct value 
	@InjectConfig(IqConfigKey.EXPOSURE_ALLOCATION_DATA_CORRELATION)
	private static readonly exposureAllocationDataCorrelation: { [relevantSubAof: string]: string[] } = {};

	/** 
	 * Returns a list of all the relevant exposure outliers sub areas of focus from the config
	 * These are different from the sub-areas of focus for exposure outliers, they get populated even if
	 * the area of focus is not flagged for the fund to allow us to populate relevant data in the table
	 */
	public static getRelevantExposureOutliersSubAofs(): string[] {
		return Object.keys(this.exposureAllocationDataCorrelation);
	}

	/**
	 * Checks which sub-aof is relevant for the fund and then adds up all the corresponding data points provided in the config
	 * @param position : The WwePosition object corresponding to the fund - comes from the positionDetails store
	 * @returns the number value for the % allocation to exposure column under the exposure outliers AOF
	 *          (undefined if no sub-aof is relevant and nan if a relevant data point is missing)
	 */
	public static calculateAllocationToExposure(position: PasPosition): number {
		const relevantSubAof: string = this.getRelevantExposureOutliersSubAofs().find(subAof => position.customClientProperties?.[subAof] === 'true');
		if (!!relevantSubAof) {
			const valuesToAddUp: number[] = this.exposureAllocationDataCorrelation?.[relevantSubAof]?.map(expression => get(position, expression));
			return valuesToAddUp.reduce((a, b) => a + b, 0);
		}
		return undefined;
	}
}
